import { render, staticRenderFns } from "./EventPayout.vue?vue&type=template&id=8b5c81d0"
import script from "./EventPayout.vue?vue&type=script&lang=js"
export * from "./EventPayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports